import React from 'react'
import { connect } from 'react-redux'

import { Show, SimpleShowLayout } from 'components/detail'
import { FunctionField } from 'components/field'

import * as urls from './urls'
import * as utils from './utils'
import { getActiveLanguage } from 'util/constants';

import { crudGetList as crudGetListAction } from 'actions/dataActions';


function getValueFromList(choices, value) {
  const choice = choices.find((choice) => (choice.id === value));
  if (choice) {
    return choice.name || '-';
  }

  return '-';
}

export const ReminderConfigUpdateDetailBase = (props) => {
  const active_lang = getActiveLanguage();
  return (
    <Show 
      {...props}
      basePath={urls.reminderConfigFrontendPath}
      editPath={`update/`}
      hasEdit={true}
      title="View New Update Reminder"
    >
      <SimpleShowLayout>
        <FunctionField 
          label="App" 
          render={(record) => (
            getValueFromList(utils.APP_TYPE_LIST, record.app_type)
          )}
        />
        <FunctionField 
          label="Platform" 
          render={(record) => (
            getValueFromList(utils.CLIENT_TYPE_LIST, record.client_type)
          )}
        />
        <FunctionField 
          label="Version" 
          render={(record) => {
            if (
              record.latest_version_info
              && record.latest_version_info.version_number
            ) {
              return record.latest_version_info.version_number;
            }
            return "-";
          }}
        />
        <FunctionField 
          label="What's New (EN)" 
          render={(record) => {
            if (
              record.latest_version_info
              && record.latest_version_info.changelog_en
            ) {
              const changelog = record.latest_version_info.changelog_en;
              const display = changelog.split('\n').map((row, i) => {
                return <div key={i}>{row}</div>;
              });
              return display;
            }
            return "-";
          }}
        />
        <FunctionField 
          label={`What's New (${active_lang.toUpperCase()})`}
          render={(record) => {
            if (
              record.latest_version_info
              && record.latest_version_info[`changelog_${active_lang}`]
            ) {
              const changelog = record.latest_version_info[`changelog_${active_lang}`];
              const display = changelog.split('\n').map((row, i) => {
                return <div key={i}>{row}</div>;
              });
              return display;
            }
            return "-";
          }}
        />
      </SimpleShowLayout>
    </Show>
  )
};

export const ReminderConfigUpdateDetail = connect(
  () => ({}),
  {
    customFetch: () => (
      crudGetListAction(
        utils.ReminderConfigResourceName, 
        urls.reminderConfigBackendPath,
        {}
      )
    ),
  }
)(ReminderConfigUpdateDetailBase);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/ReminderConfigUpdateDetail.js